import React from 'react';
import { Controller } from 'react-hook-form';
import TextInput from '../../../components/form/TextInput';
import ReactQuill from 'react-quill';

const Information = ({ isEditable, loading, form }) => {
  const modules = {
    toolbar: [
      [{ font: [] }],
      [{ size: [] }],
      [{ header: [1, 2, 3, 4, 5, 6, false] }],
      [{ color: [] }, { background: [] }],
      [{ script: 'sub' }, { script: 'super' }],
      ['bold', 'italic', 'underline', 'strike'],
      ['blockquote', 'code-block'],
      [{ list: 'ordered' }, { list: 'bullet' }],
      [{ indent: '-1' }, { indent: '+1' }],
      [{ align: [] }],
      ['link', 'image', 'video'],
      ['clean']
    ]
  };
  return (
    <div className="tabs__content pt-30 js-tabs-content">
      <div className="tabs__pane -tab-item-1 is-tab-el-active">
        <div className="overflow-scroll scroll-bar-1">
          <Controller
            control={form.control}
            name="site_name"
            render={({ field: { onChange, onBlur, value } }) => (
              <TextInput
                disabled={loading || !isEditable}
                onChange={onChange}
                onBlur={onBlur}
                value={value}
                type="text"
                isRequired={true}
                label="Nama site"
                isError={Boolean(form.formState.errors.site_name)}
                errorMessage={
                  Boolean(form.formState.errors.site_name) &&
                  form.formState.errors.site_name.message
                }
              />
            )}
          />
          <Controller
            control={form.control}
            name="overview_id"
            render={({ field: { onChange, onBlur, value } }) => (
              <div style={{ marginBottom: 42 }}>
                <label className="fw-600 text-dark">
                  Overview (ID) <span className="text-danger">*</span>
                </label>
                <ReactQuill
                  className={`${Boolean(form.formState.errors.overview_id) && 'form-error'}`}
                  readOnly={loading || !isEditable}
                  theme="snow"
                  onChange={onChange}
                  onBlur={onBlur}
                  value={value}
                  modules={modules}
                />

                {Boolean(form.formState.errors.overview_id) && (
                  <span className="text-14 text-danger">
                    {form.formState.errors.overview_id.message}
                  </span>
                )}
              </div>
            )}
          />
          <Controller
            control={form.control}
            name="overview_en"
            render={({ field: { onChange, onBlur, value } }) => (
              <div style={{ marginBottom: 42 }}>
                <label className="fw-600 text-dark">
                  Overview (EN) <span className="text-danger">*</span>
                </label>
                <ReactQuill
                  className={`${Boolean(form.formState.errors.overview_en) && 'form-error'}`}
                  readOnly={loading || !isEditable}
                  theme="snow"
                  onChange={onChange}
                  onBlur={onBlur}
                  value={value}
                  modules={modules}
                />
                {Boolean(form.formState.errors.overview_en) && (
                  <span className="text-14 text-danger">
                    {form.formState.errors.overview_en.message}
                  </span>
                )}
              </div>
            )}
          />
        </div>
      </div>
    </div>
  );
};

export default Information;
